import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { tap } from 'rxjs';
import { countyDisplayFn } from '../../../shared/functions/auto-complete-functions';
import { FormatPhoneNumberPipe } from '../../../shared/pipes/format-phone-number';
import { LookupsService } from '../../../shared/services/lookups-service';
import { County, OrganizationByCountyCode } from '../../../state/lookups/lookups-model';

@Component({
  selector: 'app-contact-us',
  imports: [MatCardModule, MatFormFieldModule, MatSelectModule, MatAutocompleteModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, FormatPhoneNumberPipe],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent implements OnInit {
  private lookupsService = inject(LookupsService);
  counties: County[] = [];
  filteredCounties: County[] = [];
  organizations: OrganizationByCountyCode[] | null = null;
  selectedCounty: County | string | null = null;

  countyDisplayValueFn = countyDisplayFn;

  ngOnInit(): void {
    this.lookupsService.getCounties().subscribe((counties) => {
      this.counties = counties;
      this.filteredCounties = counties;
    });
  }

  onClearCounty() {
    this.selectedCounty = null;
    this.organizations = null;
    this.filteredCounties = this.counties;
  }

  onSearchChange(value: string | County | null): void {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.countyName?.toLowerCase() || '';

    if (!filterValue) {
      this.filteredCounties = this.counties;
      return;
    }

    this.filteredCounties = this.counties.filter((county) => county.countyName.toLowerCase().includes(filterValue));
  }

  onCountySelected(selectedCounty: County): void {
    this.lookupsService
      .organizationsByCountyCode(selectedCounty.countyCode)
      .pipe(
        tap((organizations) => {
          this.organizations = organizations;
        }),
      )
      .subscribe();
  }
}
